
<template>
  <div>
    <div class="detail-head">
      <h3 class="title">订单信息</h3>
      <div class="tip">
        收付款编号: {{ row.paymentsNum }} | 创建人: {{ row.createUser }} |
        创建日期: {{ row.createTime }}
      </div>
    </div>
    <div class="clearfix">
      <div class="add-box clearfix" style="margin-bottom: 10px">
        <!-- :span-method="spanMethod" -->
        <vxe-table
            border
            show-overflow
            keep-source
            ref="t1"
            align="center"
            auto-resize
            highlight-hover-row
            class="table_insert"
            :edit-rules="editRules"
            :data="ordersList"
            :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
            @cell-click="cellClick"
        >
          <vxe-table-column field="chainNum" title="主订单编号" style="wdith: 10%">
            <template v-slot="{ row }">
              <div>
                <div>{{ row.chainNum }}</div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="ordersNumb" title="子订单编号" style="wdith: 10%">
            <template v-slot="{ row }">
              <div class="link-text">
                {{
                row.ordersNumb == "" || row.ordersNumb == null
                ? "选择关联订单"
                : row.ordersNumb
                }}
              </div>
            </template>
          </vxe-table-column>

          <!-- 平台跟购买方 -->
          <vxe-table-column field="buyerName" title="托运人名称" v-if="cate == 'Collection'" style="wdith: 10%"
          ></vxe-table-column>
          <vxe-table-column field="compName" title="平台企业" v-if="cate == 'Collection'" style="wdith: 10%"
          ></vxe-table-column>

          <!-- 平台跟承运人 -->
          <vxe-table-column field="sellerName" title="承运人名称" v-if="cate == 'Payment'" style="wdith: 10%"
          ></vxe-table-column>
          <vxe-table-column field="compName" title="平台企业" v-if="cate == 'Payment'"
                            style="wdith: 10%"></vxe-table-column>

          <!-- 平台跟实际承运人 -->
          <vxe-table-column field="buyerName" title="托运人名称" v-if="cate == 'SellerPayment'" style="wdith: 10%"
          ></vxe-table-column>
          <vxe-table-column field="compName" title="平台企业" v-if="cate == 'SellerPayment'"
                            style="wdith: 10%"></vxe-table-column>
          <vxe-table-column field="sellerName" title="承运人名称" v-if="cate == 'SellerPayment'"
                            style="wdith: 10%"></vxe-table-column>
          <vxe-table-column field="sellerLv2Name" title="实际承运人名称" v-if="cate == 'SellerPayment'"
                            style="wdith: 10%"></vxe-table-column>

          <vxe-table-column field="aboutAmount" title="关联金额" style="wdith: 10%"></vxe-table-column>
        </vxe-table>
      </div>

      <div>
        <h3 class="title">收付款信息</h3>
      </div>
      <div class="add-box clearfix">
        <vxe-table
            border
            show-overflow
            keep-source
            ref="t2"
            class="table_insert"
            :auto-resize="true"
            :edit-rules="editRules"
            :data="tableData"
            :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
            @cell-click="cellClick"
        >
          <!-- 2020-09-18 新增 所属公司 业务员 客户名称-->
          <vxe-table-column field="compName" title="所属公司" align="center" style="height: 100%" :show-overflow="false">
          </vxe-table-column>
          <vxe-table-column field="salesMan" title="业务员" align="center">
            <template v-slot="scope">
              <div>
                <sales-man
                    :row="scope.row"
                    :field="'salesMan'"
                ></sales-man>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
              field="clientName"
              title="客户名称"
              align="center"
              :show-overflow="false"
          >
            <template v-slot="{ row }">
              <div>
                <div class="large-name">
                  <div class="link-text" @click="openChooseAccount(row, 'clientName')">
                    {{ row.clientName ? row.clientName : "选择客户" }}
                  </div>
                </div>
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column field="addTime" width="90" title="日期"></vxe-table-column>
          <vxe-table-column field="note" title="摘要" width="80" :show-overflow="false"></vxe-table-column>

          <!-- 实际承运人  两个都是 用户 -->
          <vxe-table-column field="paymentsName" title="付款企业(人)名称" width="160" v-if="cate == 'SellerPayment'" :show-overflow="false">
            <template v-slot="{ row }">
              <div>
                <div class="inner-column large-name">
                  <div class="large-name-text">
                    {{ row.paymentsName }}
                  </div>
                </div>
                <div class="inner-column-title">收款企业(人)名称</div>
                <div class="large-name-text">
                  {{ row.recName }}
                </div>
              </div>
            </template>
          </vxe-table-column>
          <!-- 托运人订单 和 承运人订单  一个是平台 一个是用户 -->
          <vxe-table-column field="paymentsName" title="付款企业(人)名称" width="160" v-else :show-overflow="false">
            <template v-slot="{ row }">
              <div>
                <div class="inner-column large-name">
                  <div class="large-name-text">
                    {{ row.paymentsName }}
                  </div>
                </div>
                <div class="inner-column-title">收款企业(人)名称</div>
                <div class="large-name-text">
                  {{ row.recName }}
                </div>
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column field="payBank" title="开户行" width="200" :show-overflow="false">
            <template v-slot="{ row }">
              <div>
                <div class="inner-column large-name">
                  <div class="large-name-text">
                    {{ row.payBank }}
                  </div>
                </div>
                <div class="inner-column-title">开户行</div>
                <div class="inner-column large-name">
                  <div class="large-name-text">
                    {{ row.recBank }}
                  </div>
                </div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="payAccount" title="银行卡号" width="120" :show-overflow="false">
            <template v-slot="{ row }">
              <div>
                <div class="inner-column large-name">
                  <div class="large-name-text">
                    {{ row.payAccount }}
                  </div>
                </div>
                <div class="inner-column-title">银行卡号</div>
                <div class="inner-column large-name">
                  <div class="large-name-text">
                    {{ row.recAccount }}
                  </div>
                </div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="payAmount" title="总金额" :show-overflow="false"></vxe-table-column>
          <vxe-table-column field="usedAmount" title="已关联金额">
             <template v-slot="{ row }">
              {{Math.round((row.usedAmount)*100)/100}}
            </template>
          </vxe-table-column>
          <vxe-table-column :show-overflow="false" field="unusedAmount" title="未关联金额">
            <template v-slot="{ row }">
              {{Math.round((row.payAmount - row.usedAmount)*100)/100}}
            </template>
          </vxe-table-column>
          <vxe-table-column field="payBankCode" title="支付凭证流水号" :show-overflow="false"></vxe-table-column>
        </vxe-table>
        <div>
          <vxe-table
              border
              show-overflow
              keep-source
              :data="tableData"
              class="table_insert"
              max-height="140"
              :auto-resize="true"
              :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
          >
            <vxe-table-column field="fileList" title="查看附件">
              <template v-slot="{ row }">
                <upload-list
                    :isEdit="false"
                    :row="row"
                    :initFileList="row.fileList"
                    :view="'arrange'"
                    ref="uploadList"
                ></upload-list>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <div class="add-btn-box" v-if="row.isOnline === 0 && authUpdate()">
          <Button status="primary" @click="submitEvent">提交</Button>
        </div>
      </div>

      <!-- 弹窗 -->
      <!-- 选择关联订单 -->
      <vxe-modal v-model="isShowChooseOrder" width="1300" height="650" resize remember title="选择订单">
        <choose-order
            :chainId="chainId"
            @choose="chooseOrderEvent"
            ref="refPaymentAboutOrder"
        ></choose-order>
      </vxe-modal>

      <!-- 选择企业 -->
      <vxe-modal v-model="isShowChooseAccount" width="800" height="600" resize remember title="选择客户">
        <choose-account
            @choose="chooseAccountEvent"
            ref="chooseAccount"
        ></choose-account>
      </vxe-modal>

      <!-- 选择银行账户 -->
      <vxe-modal v-model="isShowBankAccountModal" width="900" height="660" resize remember title="选择银行账户">
        <bank-account @choose="chooseBankAccount" :isShow="isShowBankAccountModal" ref="bankAccountModal"
        ></bank-account>
      </vxe-modal>
    </div>
  </div>
</template>

<script>
  import $api from '@/apiProvider'
  import UploadList from '@/components/common/UploadList'
  import BankAccount from '@/components/modal/BankAccount'
  import Account from '@/components/modal/Account'
  import SalesMan from '@/components/common/SalesMan'
  import getAuthOrization from "@/mixin/getAuthOrization";
  import {orderDetail, showLoading, hideLoading, isNotEmpty} from '@/utils/util'
  import {isEmpty} from "xe-utils/methods";
  import AboutCollectionOrder from "@/components/order/AboutCollectionOrder";

  const assign = (val) => Object.assign({}, val)
  const empties = [undefined, '', null, 'null', {}, [], '[]']

  export default {
    mixins: [getAuthOrization],
    name: 'Clearing',
    components: {
      SalesMan,
      ChooseOrder: AboutCollectionOrder,
      BankAccount,
      UploadList,
      ChooseAccount: Account
    },
    props: {
      cate: {
        type: String,
        default: ''
      },
      isShow: {
        type: Boolean,
        default: false
      },
      chainId: Number
    },
    data() {
      return {
        queryAction: '',
        updateAction: '',
        paymentId: 0,
        isShowChooseOrder: false,
        amountListName: '',
        isShowChooseAccount: false,
        isShowBankAccountModal: false,

        ordersList: [], //关联的订单数据
        orderTmp: {
          "id": null,
          "ordersId": null,
          "aboutAmount": null,
          "buyerName": null,
          "chainNum": null,
          "compName": null,
          "ordersNumb": null,
          "sellerName": null,
        },
        row: {},
        tableData: [], //详情收付款数据 只有一条
        editRules: {
          payAmount: [
            {validator: this.requireValid}
          ],
          // salesMan: [
          //   {validator: this.requireValid}
          // ],
          addTime: [
            {validator: this.requireValid}
          ],
          note: [
            {validator: this.requireValid}
          ],
          paymentsName: [
            {validator: this.requireValid}
          ],
          recName: [
            {validator: this.requireValid}
          ]
        },
      };
    },
    watch: {
      isShow: {
        deep: true,
        immediate: true,
        handler: function (newVal, oldVal) {
          //关闭弹窗
          if (newVal == false && oldVal == true) {
            this.clearValidate()
          }
        }
      },
      cate: {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          switch (this.cate) {
            case 'Collection':
              this.amountListName = 'ordersBuyerAmountList'
              this.queryAction = 'queryPaymentsBuyerDetail'
              this.updateAction = 'updatePaymentsBuyer'
              break
            case 'Payment':
              this.amountListName = 'ordersSellerAmountList'
              this.queryAction = 'queryPaymentsSellerDetail'
              this.updateAction = 'updatePaymentsSeller'
              break
            case 'SellerPayment':
              this.amountListName = 'ordersSellerLv2sAmountList'
              this.queryAction = 'queryPaymentsSellerLv2Detail'
              this.updateAction = 'updatePaymentsSellerLv2'
              break
          }
        }
      },
    },
    methods: {
      async init(paymentId) {
        this.paymentId = paymentId
        this.getData()
      },
      async getData() {
        let res = await $api.payments.request(this.queryAction, {id: this.paymentId})
        if (res.status == 1) {
          let row = res.data
          // this.orderTmp.aboutAmount = row.payAmount
          // console.log(row, 'aaaaaaa');
          //详情数据从详情接口去取
          if (row.addTime != null) {
            row.addTime = this.$utils.toDateString(row.addTime, 'yyyy-MM-dd')
          }
          if (row.createTime != null) {
            row.createTime = this.$utils.toDateString(row.createTime, 'yyyy-MM-dd')
          }
          if (empties.includes(row.ordersList) || row.ordersList.length == 0) {
            this.ordersList = [assign(this.orderTmp)]

          } else {
            this.ordersList = row.ordersList
            row[this.amountListName] = row.ordersList
          }
          row.unusedAmount = parseFloat(row.unusedAmount).toFixed(2)
          this.row = row
          this.tableData = [row]
          console.log(this.tableData, 'rowwwww');
          // debugger
          if (isEmpty(row.fileList) && undefined != this.$refs.uploadList) {
            this.$refs.uploadList.init([])
          }
        } else {
          if (empties.includes(res.message)) {
            res.message = '接口异常'
          }
          this.$XModal.message({status: 'error', message: res.message})
        }
      },
      clearValidate() {
        this.$refs.t1.clearValidate()
        this.$refs.t2.clearValidate()
      },
      async requireValid(e) {
        if ([undefined, '', null, 'null', {}, []].includes(e.cellValue)) {
          return Promise.reject(new Error(e.column.title + '必填'))
        }
      },
      inputPayAmountEvent(row) {
        if (!empties.includes(row.payAmount) && row.orderNum == ' ') {
          row.orderNum = null
        }
        this.$refs.t2.clearValidate()
      },
      async validEvent() {
        const errMap1 = await this.$refs.t1.validate().catch((errMap1) => errMap1);
        if (errMap1) return false
        const errMap2 = await this.$refs.t2.validate().catch((errMap2) => errMap2);
        if (errMap2) return false
        return true
      },
      async cellClick(e) {
        let row = e.row
        let field = e.column.property
        if (field == 'ordersNumb') {
          this.openOrderModal()
        }
      },
      async selectCompName(row, id, name) {
        if (isNotEmpty(row.compName) && row.compName != name && isNotEmpty(row[this.amountListName])) {
          let confirmRes = await this.$XModal.confirm(
            "更换所属平台公司将清空关联订单",
            "是否更换"
          );
          if (confirmRes === "confirm") {
            row[this.amountListName] = []
            this.ordersList = [assign(this.orderTmp)]
          } else {
            return
          }
        }
        row.platformCompanyId = id
        row.compName = name
      },
      openChooseAccount(row, field) {
        this.isShowChooseAccount = true
        this.currentRow = row
        this.currentChooseColumn = field
        this.$refs.chooseAccount.init()
      },
      chooseAccountEvent(account, type) {
        console.log('chooseAccountEvent', account)
        this.currentRow[this.currentChooseColumn] = account.userName
        this.isShowChooseAccount = false
        this.$refs.t2.clearValidate(this.currentChooseColumn)
      },
      async openOrderModal() {
        //注意 点击关联订单的一行 实际要操作的数据却是 收付款的数据
        let row = this.tableData[0]
        if (empties.includes(row.payAmount)) {
          await this.$refs.t1.clearValidate()
          await this.$refs.t2.clearValidate()
          await this.$refs.t2.validate()
        } else {
          this.currentChooseColumn = this.amountListName
          this.currentRow = row
          this.isShowChooseOrder = true
          this.$refs.refPaymentAboutOrder.init(this.cate, row.id, row.payAmount, this.ordersList, row.platformCompanyId, row.clientName)
        }
      },
      chooseOrderEvent(ordersList, usedAmount) {
        let oldOrderlist = this.currentRow[this.amountListName]
        var oldOrdersMap = {}
        //已经关联订单列表
        if (!empties.includes(oldOrderlist)) {
          oldOrderlist.forEach(item => {
            oldOrdersMap[item.ordersId] = item.id
          })
        }
        //新选择订单列表
        if (ordersList.length > 0) {
          this.tableData[0].clientName = ordersList[0].buyerName;
          this.tableData[0].salesMan = ordersList[0].salesManName;
          this.tableData[0].salesManId = ordersList[0].salesManId;
          ordersList.forEach(item => {
            if (empties.includes(oldOrdersMap[item.id])) {
              item.id = null
            } else {
              item.id = oldOrdersMap[item.id]
            }
            if (this.cate == 'Collection') {
              item.compName = item.sellerName
            } else if (this.cate == 'Payment') {
              item.compName = item.buyerName
            } else {
              //buyerName compName sellerName sellerLv2Name
              item.sellerLv2Name = item.sellerName
              item.sellerName = item.buyerName
              item.compName = ''
              item.buyerName = ''
            }
            //付款关联金额使用 付款信息的金额
            if (this.cate != "Collection") {
              item.aboutAmount = this.currentRow.payAmount
              //所属公司-compName  业务员-salesMan  客户名称-clientName
              this.currentRow.platformCompanyId = item.platformCompanyId
              this.currentRow.platformCompanyName = item.platformCompany
              this.currentRow.salesMan = item.salesManName
              this.currentRow.salesManId = item.salesMan
              this.currentRow.clientName = item.sellerName
            }
          });
        } else {
          ordersList = [assign(this.orderTmp)]
        }
        console.log(this.currentRow, ordersList[0])

        this.currentRow[this.amountListName] = ordersList
        this.currentRow.usedAmount = usedAmount
        this.ordersList = ordersList
        this.isShowChooseOrder = false
        this.clearValidate()
      },
      openBankAccountModal(row, field, accountCate) {
        this.currentRow = row
        this.currentChooseColumn = field
        // console.log(field)
        this.isShowBankAccountModal = true
        this.$refs.bankAccountModal.init(accountCate, field, row)
      },
      chooseBankAccount(bankAccount) {
        console.log('chooseBankAccount', this.currentChooseColumn, bankAccount)
        if (this.currentChooseColumn == 'paymentsName') {
          this.currentRow.paymentsName = bankAccount.accountName
          this.currentRow.payBank = bankAccount.bankName
          this.currentRow.payAccount = bankAccount.accountNum
        } else {
          this.currentRow.recName = bankAccount.accountName
          this.currentRow.recBank = bankAccount.bankName
          this.currentRow.recAccount = bankAccount.accountNum
        }
        this.isShowBankAccountModal = false
        this.$refs.t2.clearValidate(this.currentChooseColumn)
      },
      insertOrder() {
        this.$refs.t1.clearValidate()
        this.$refs.t1.insert(assign(this.orderTmp))
      },
      deleteOrder(row) {
        this.$refs.t1.remove(row)
      },

      async submitEvent() {
        let sts = await this.validEvent()
        if (!sts) {
          this.$XModal.message({status: "error", message: "校验不通过！"});
          return
        }

        let row = assign(this.tableData[0])
        row.ownName = row.compName
        // console.log(row);
        // debugger

        row.addTime = this.$utils.timestamp(this.$utils.toStringDate(row.addTime))

        row.usedAmount = 0
        if (this.ordersList.length == 1 && (this.ordersList[0].ordersId == null)) {
          row.ordersList = []
        } else {
          row.ordersList = this.ordersList
        }

        row.ordersList.forEach(order => {
          row.usedAmount += order.aboutAmount
        })
        row.unusedAmount = row.payAmount - row.usedAmount
        row[this.amountListName] = row.ordersList
        // console.log(row);
        // debugger
        showLoading()
        let res = await $api.payments.request(this.updateAction, row)
        hideLoading()

        if (res.status == 1) {
          this.$XModal.message('提交成功')
          this.$emit('close')
          this.$emit('init')
        } else {
          if (!res.message) {
            res.message = '接口异常'
          }
          this.$XModal.message(res.message)
        }
      },
      spanMethod({rowIndex, columnIndex}) {
        if (columnIndex == 0) {
          if (rowIndex == 0) {
            return {rowspan: this.ordersList.length, colspan: 1}
          } else {
            return {rowspan: 0, colspan: 0}
          }
        } else {
          return {rowspan: 1, colspan: 1}
        }
      },
      authUpdate() {
        return this.cate == 'Collection' && this.isHavePermission('payments:updatePaymentsBuyer')
          || this.cate == 'Payment' && this.isHavePermission('payments:updatePaymentsSeller')
          || this.cate == 'SellerPayment' && this.isHavePermission('payments:updatePaymentsSellerLv2')
      },
    },
  };
</script>

<style scoped>
  .detail-head {
    position: relative;
    height: 50px;
  }

  .detail-head .title {
    height: 50px;
    line-height: 50px;
  }

  .detail-head .tip {
    position: absolute;
    right: 20px;
    top: 0;
    color: #606266;
    height: 50px;
    line-height: 50px;
    vertical-align: middle;
  }


  /* 详情 表格内样式 */
  .link-text {
    color: #2D8CF0;
    font-size: 14px;
    font-family: Roboto;
    font-weight: 400;
    margin-left: 0;
  }

  .inner-column {
    height: 50px;
    overflow: hidden;
    vertical-align: middle;
    margin: auto;
    line-height: 50px;
  }

  .inner-column-title {
    background-image: linear-gradient(#F8F8F9, #F8F8F9), linear-gradient(#F8F8F9, #F8F8F9);
    color: #808695;
    background-repeat: no-repeat;
    border-top: 1px solid #e8eaec;
    border-bottom: 1px solid #e8eaec;
    line-height: 50px;
    height: 50px;
    overflow: hidden;
    vertical-align: middle;
  }


  .large-name {
    text-align: center;
    vertical-align: middle !important;
    position: relative;
    padding: 0;
    clear: both;
  }


  .large-name-text {
    margin: auto;
    /* display: inline-block; */
    /* word-wrap: break-word !important;
    word-break: normal !important;
    vertical-align: middle !important; */
    width: 100%;
    line-height: 16px;
    height: 50px;
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    
    text-align: justify;
    word-break: break-all !important;
  }
</style>